'use client';

import type { SelectableCardProps } from '../types';
import { selectableCardIconStyles, selectableCardIndicatorStyles, selectableCardStyles } from './styles';
import Check from '/public/icons/check-btn.svg';

export function SelectableCard({
  title,
  icon,
  selected = false,
  disabled = false,
  invalid = false,
  onClick,
}: SelectableCardProps) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      disabled={disabled}
      onClick={onClick}
      className={selectableCardStyles({ selected, disabled, invalid })}
    >
      <span className={selectableCardIndicatorStyles({ selected, disabled })}>
        {selected && <Check className="h-4 w-4" />}
      </span>

      <div className={selectableCardIconStyles({ selected })}>{icon}</div>

      <h5 className="text-black">{title}</h5>
    </button>
  );
}
